import {default as parse} from './parse';

export default {parse};
